var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "view-loader",
    {
      attrs: { loading: !!_vm.loading },
      scopedSlots: _vm._u([
        {
          key: "label",
          fn: function() {
            return [
              _c("h2", [_vm._v(_vm._s(_vm.trans("please_wait")) + "...")])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("overproduction-search", {
        attrs: { date: _vm.date, disableSaveButtons: _vm.disableSaveButtons },
        on: {
          "update:date": function($event) {
            _vm.date = $event
          },
          disableSaveButtons: _vm.onDisableSaveButtons,
          searchOverproduction: _vm.onSearchOverproduction,
          getBrands: _vm.onGetBrands,
          getDeliveryType: _vm.onGetDeliveryType,
          getFormDate: _vm.onGetFormDate
        }
      }),
      _vm._v(" "),
      _vm.overproductionData.length
        ? _c("overproduction-table", {
            attrs: { overproductionData: _vm.overproductionData },
            on: { save: _vm.save }
          })
        : _vm.wasSearched && !_vm.loading
        ? _c("div", { staticClass: "alert alert-info" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.trans("overproduction.empty_overproduction_planning")
                ) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("action-buttons", {
        attrs: {
          date: _vm.date,
          disableSaveButtons: _vm.disableSaveButtons,
          sellBrands: _vm.sellBrands,
          productionBrands: _vm.productionBrands,
          deliveryType: _vm.deliveryType,
          formDate: _vm.formDate
        },
        on: {
          "update:date": function($event) {
            _vm.date = $event
          },
          sendToProduction: _vm.sendToProduction,
          save: _vm.save
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d3693f62", { render: render, staticRenderFns: staticRenderFns })
  }
}